import { render } from "./WatchFundTile.vue?vue&type=template&id=3a303529&scoped=true"
import script from "./WatchFundTile.vue?vue&type=script&lang=js"
export * from "./WatchFundTile.vue?vue&type=script&lang=js"

import "./WatchFundTile.vue?vue&type=style&index=0&id=3a303529&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a303529"]])

export default __exports__